// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export enum CtsGantryInitEventEType {
  STANDBY = 'Standby',
  COMPLETED_WITH_ERROR = 'CompletedWithError',
  INCOMPLETE = 'Incomplete',
  AUTOREBOOT = 'Autoreboot',
  UNKNOWN = 'Unknown',
}
